import { render, staticRenderFns } from "./giveTo.vue?vue&type=template&id=5f1e1673&scoped=true&"
import script from "./giveTo.vue?vue&type=script&lang=js&"
export * from "./giveTo.vue?vue&type=script&lang=js&"
import style0 from "./giveTo.vue?vue&type=style&index=0&id=5f1e1673&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1e1673",
  null
  
)

export default component.exports